import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AuthService, ImpersonationService, SidebarService } from '../../services';

@Component({
  selector: 'app-mobile-header',
  imports: [ButtonModule],
  templateUrl: './mobile-header.component.html',
  styleUrl: './mobile-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileHeaderComponent {
  private readonly authService = inject(AuthService);
  private readonly sidebarService = inject(SidebarService);
  private readonly impersonationService = inject(ImpersonationService);

  get userName(): string {
    return this.authService.getFullName() || 'User';
  }

  readonly isImpersonationAllowed = this.impersonationService.isAllowed;
  readonly isImpersonating = this.impersonationService.isImpersonating;
  readonly impersonatedName = computed(() => this.impersonationService.impersonatedUser()?.fullName ?? '');

  toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
  }

  stopImpersonating(): void {
    this.impersonationService.stopImpersonation();
  }
}
